







































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip, mdbProgress } from '@folky-tools/mdbvue';
import { VueGoodTable } from '@folky-tools/vue-good-table';
import Swal from 'sweetalert2';
import { String } from 'typescript-string-operations';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Reference } from '@/models/references/reference';
import { ReferenceImage } from '@/models/references/reference-image';
import { axiosService, referencesService, referencesClassificationService, authorizationManagerService, businessFrontPagesService, notificationsService, usersService } from '@/services';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbProgress,
        VueGoodTable,
        NewReference: () => import('@/components/references/NewReference.vue'),
        EditReferenceBasicData: () => import('@/components/references/EditReferenceBasicData.vue'),
        EditReferenceImages: () => import('@/components/references/EditReferenceImages.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class ServicesListView extends Vue {
    private actualUserCanCreateServices: boolean = false;
    private rows: any[] = [];
    private columns: any[] = [];
    private totalRecords: number = 0;
    private isLoading: boolean = false;
    private servicesPerPage: number = 20;

    private serverParams: any = {
        columnFilters: {
            displayTitle: '',
            categoryName: '',
            businessTradeName: ''
        },
        sort: [
            {
                field: 'id',
                type: 'desc'
            }
        ],
        page: 1,
        perPage: this.servicesPerPage
    };

    private showEditServiceModal: boolean = false;
    private selectedService: Reference = new Reference();
    private selectedServiceCopy: Reference = new Reference();
    private showEditImagesModal: boolean = false;

    private async beforeMount(): Promise<void> {
        await this.setColumns();
        await this.loadItems();
    }

    private async mounted(): Promise<void> {
        this.actualUserCanCreateServices = authorizationManagerService.canCreateReferences;

        if (this.$route.query.businessName) {
            this.$root.$emit('change-active-page', 'views.services.servicesListView.titleSingleBusiness', this.$route.query.businessName.toString());
        } else {
            this.$root.$emit('change-active-page', 'views.services.servicesListView.title');
        }

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Services,
                scope: UserActionScopeType.List
            })
        );
    }

    private async onPageChange(params: any): Promise<void> {
        this.serverParams.page = params.currentPage;
        await this.loadItems();
    }

    private async onPerPageChange(params: any): Promise<void> {
        this.serverParams.perPage = params.currentPerPage;
        await this.loadItems();
    }

    private async onSortChange(params: any): Promise<void> {
        if (params[0].field !== this.serverParams.sort[0].field || params[0].type !== this.serverParams.sort[0].type) {
            this.serverParams.sort[0].field = params[0].field === 'displayTitle' ? 'title' : params[0].field;
            this.serverParams.sort[0].type = params[0].type;
            await this.loadItems();
        }
    }

    private async onColumnFilter(params: any): Promise<void> {
        if (
            params.columnFilters.displayTitle !== this.serverParams.columnFilters.displayTitle ||
            params.columnFilters.categoryName !== this.serverParams.columnFilters.categoryName ||
            params.columnFilters.businessTradeName !== this.serverParams.columnFilters.businessTradeName
        ) {
            this.serverParams.page = 1;
            this.serverParams.columnFilters = JSON.parse(JSON.stringify(params.columnFilters));
            await this.loadItems();
        }
    }

    private async loadItems(): Promise<void> {
        this.isLoading = true;

        const response: any = await axiosService.instance.get('references/organization/Service/query?additionalType=RentalService', {
            params: await this.getQueryParams(this.serverParams.sort, this.serverParams.page, this.serverParams.perPage)
        });

        this.rows = [];

        this.totalRecords = response.data.count;
        response.data.items.forEach((item: any) => {
            this.rows.push(new Reference(item));
        });

        this.isLoading = false;
    }

    private async getQueryParams(sortOrder: any, currentPage: number, perPage: number): Promise<any> {
        return {
            $skip: (currentPage - 1) * perPage,
            $top: perPage,
            $orderby: this.getQueryOrderFromColumn(sortOrder),
            $filter: await this.getQueryFilterFromColumns()
        };
    }

    private getQueryOrderFromColumn(sortOrder: any): string | null {
        if (sortOrder && sortOrder.length === 1) {
            if (sortOrder[0].field === 'created') {
                return `createdUtc ${sortOrder[0].type}`;
            } else {
                return `${sortOrder[0].field} ${sortOrder[0].type}`;
            }
        } else {
            return null;
        }
    }

    private async getQueryFilterFromColumns(): Promise<string | null> {
        let queryFilter = '';
        const logicalOperatorBetweenFilters = ' and ';

        for (const key of Object.keys(this.serverParams.columnFilters)) {
            if (this.serverParams.columnFilters[key]) {
                if (key === 'displayTitle') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(title, '${this.serverParams.columnFilters[key].replace('\'', '\'\'')}')`;
                }
                if (key === 'businessTradeName') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(businessTradeName, '${this.serverParams.columnFilters[key].replace('\'', '\'\'')}')`;
                }
                if (key === 'categoryName') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(categoryName, '${this.serverParams.columnFilters[key].replace('\'', '\'\'')}')`;
                }
            }
        }

        return queryFilter === '' ? null : queryFilter.substring(logicalOperatorBetweenFilters.length);
    }

    private setColumns(): void {
        this.columns = [
            {
                field: 'id',
                type: 'number',
                sortable: true
            }
        ];

        this.columns.push({ field: 'images', type: 'number', sortable: false });

        this.columns.push({
            field: 'displayTitle',
            sortable: true,
            filterOptions: {
                enabled: true,
                placeholder: this.$t('common.placeholders.searchByName'),
                filterValue: ''
            }
        });

        this.columns.push({
            field: 'categoryName',
            sortable: false,
            filterOptions: {
                enabled: true,
                placeholder: this.$t('common.placeholders.searchByCategory'),
                filterValue: ''
            }
        });

        this.columns.push({ field: 'formattedPrincipalSkuPrice', sortable: false, type: 'number' });

        if (authorizationManagerService.isAdmin || authorizationManagerService.canReadMultipleBusinesses) {
            this.columns.push({
                field: 'businessTradeName',
                sortable: false,
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchByBusiness'),
                    filterValue: ''
                }
            });
        }

        if (authorizationManagerService.isAdmin) {
            this.columns.push({ field: 'created', sortable: true });
        }

        this.columns.push({ field: 'isPublishedInAConsumer', sortable: true });
        this.columns.push({ field: 'actions-slot', sortable: false });
    }

    private async editService(service: Reference): Promise<void> {
        this.selectedService = service;
        this.showEditServiceModal = true;

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Services,
                scope: UserActionScopeType.Edit,
                entityId: this.selectedService.id
            })
        );
    }

    private async onServiceWasSavedSuccessfully(): Promise<void> {
        const service = await referencesService.getReference(this.selectedService.id);
        this.selectedService.category = service.category.clone();
        this.selectedService.title = service.title;
        this.selectedService.description = service.description;
        this.selectedService.skus = service.skus.map(sku => sku.clone());
        this.selectedService.particularConditions = service.particularConditions;
        this.showEditServiceModal = false;
    }

    private onCloseEditServiceModal(): void {
        this.showEditServiceModal = false;
    }

    private async editImages(service: Reference): Promise<void> {
        this.selectedService = service;
        this.selectedServiceCopy = service.clone();
        const images: ReferenceImage[] = await referencesService.getReferenceImages(this.selectedService.id);
        this.selectedService.images = [...images];
        this.selectedServiceCopy.images = [...images];
        this.showEditImagesModal = true;
    }

    private onCloseEditImagesModal(): void {
        this.selectedService.images = [];
        this.selectedServiceCopy.images = [];
        this.showEditImagesModal = false;
    }

    private onUpdateSelectedServiceImageCount(updatedImageCount: number): void {
        this.selectedService.imagesCount = updatedImageCount;
    }

    private async publishService(service: Reference): Promise<void> {
        if (service.businessId && !(await businessFrontPagesService.isPublishedBusinessFrontPage(service.businessId, true))) {
            notificationsService.showToastWarningNotification('views.services.servicesListView.publish.modal.notification.warningFirstPublishFrontpage');
            return;
        }

        const questionResult = await Swal.fire({
            title: service.title ? String.Format(this.$i18n.t('views.services.servicesListView.publish.modal.titleWithName').toString(), service.title) : this.$i18n.t('views.services.servicesListView.publish.modal.title').toString(),
            html: this.$i18n.t('views.services.servicesListView.publish.modal.textHtml').toString() + this.$i18n.t('common.warning.changesInWebTakeTime').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: true,
            confirmButtonText: this.$i18n.t('views.services.servicesListView.publish.modal.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.services.servicesListView.publish.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            if (await referencesService.publishReference(service.id)) {
                notificationsService.showToastSuccessNotification('views.services.servicesListView.publish.modal.notification.successMessage');
                service.isPublishedInAConsumer = true;

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Services,
                        scope: UserActionScopeType.Publication,
                        entityId: service.id
                    })
                );

                return;
            }

            notificationsService.showToastErrorNotification();
        }
    }

    private async unpublishService(service: Reference): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$i18n.t('views.services.servicesListView.unpublish.modal.title').toString(),
            html: this.$i18n.t('views.services.servicesListView.unpublish.modal.textHtml').toString() + this.$i18n.t('common.warning.changesInWebTakeTime').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: true,
            confirmButtonText: this.$i18n.t('views.services.servicesListView.unpublish.modal.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.services.servicesListView.unpublish.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            if (await referencesService.unpublishReference(service.id)) {
                notificationsService.showToastSuccessNotification('views.services.servicesListView.unpublish.modal.notification.successMessage');
                service.isPublishedInAConsumer = false;

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Services,
                        scope: UserActionScopeType.Publication,
                        entityId: service.id
                    })
                );

                return;
            }

            notificationsService.showToastErrorNotification();
        }
    }

    private async deleteService(id: number): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$i18n.t('views.services.servicesListView.actions.delete.modal.title').toString(),
            text: this.$i18n.t('views.services.servicesListView.actions.delete.modal.text').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: true,
            confirmButtonText: this.$i18n.t('views.services.servicesListView.actions.delete.modal.confirm.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.services.servicesListView.actions.delete.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            if (await referencesService.deleteReference(id)) {
                notificationsService.showToastSuccessNotification('views.services.servicesListView.actions.delete.modal.confirm.successMessage');
                await this.loadItems();

                return;
            }

            notificationsService.showToastErrorNotification();
        }
    }

    private async copyToClipboard(text: string): Promise<void> {
        await navigator.clipboard.writeText(text);
        notificationsService.showToastInfoNotification('views.services.servicesListView.actions.copyToClipboard.successMessage');
    }
}
